const form = {
  id: 'general',
  title: 'General',
  description: 'General compliance form for all internal purposes.',
  questions: [
    { label: 'Inspector', type: 'user', required: true },
    {
      label: 'Location',
      type: 'select',
      required: true,
      values: ['Brisbane, QLD, Australia', 'Sydney, NSW, Australia', 'Melbourne, VIC, Australia', 'Eden Prairie, MN, USA', 'Tulsa, OK, USA'],
    },
    { label: 'Details', type: 'heading' },
    { label: 'Purpose of Inspection', type: 'text', required: true },
    {
      label: 'Inspection Type',
      type: 'checkboxes',
      values: ['Safety Inspection', 'Quality Inspection', 'Compliance Inspection', 'Other'],
      required: true,
    },
    { label: 'Inspection Checklist', type: 'heading' },
    {
      label: 'Safety Measures',
      type: 'checkboxes',
      values: ['Adequate signage and warnings', 'Proper use of Personal Protective Equipment (PPE)'],
      required: true,
    },
    {
      label: 'Quality Control',
      type: 'checkboxes',
      values: ['Quality of products/materials', 'Workmanship and craftsmanship'],
      required: true,
    },
    {
      label: 'Compliance',
      type: 'checkboxes',
      values: ['Adherence to regulations and standards', 'Permits and licenses'],
      required: true,
    },
    { label: 'Comments', type: 'textarea' },
    {
      label: 'Recommendations',
      type: 'checkboxes',
      values: ['No action required', 'Corrective actions needed', 'Follow-up inspection required'],
      required: true,
    },
  ],
};

export default form;
